import {
  Tier_Pass as Tier,
  TierGroup,
} from '@pass-frontend/data-access/common/edge';

export const isSubsidized = (tier: Tier | null) => {
  if (!tier) return;
  return (
    Number(tier.monthlyFee ?? 0) === 0 && Number(tier.enrollmentFee ?? 0) === 0
  );
};

export const doesTierGroupContainSubsidized = (
  tierGroup: Pick<TierGroup, 'tiers'> | undefined,
) => {
  return tierGroup?.tiers?.some((tier) => isSubsidized(tier));
};
